<script>
// import ClienteController from '@/shared/controllers/cliente/clienteController'
import { defineComponent } from 'vue'
import InputTelefone from '../InputTelefone/InputTelefone.vue'
const name = 'InputClienteTelefone'

export default defineComponent({
  name,

  components: { InputTelefone },
	emits: ['update:modelValue','invalido'],
  props: {
		modelValue: {
			type: String,
      default: ''
		},
    clienteId: {
      type: String,
      default: ''
    }
  },

  mounted() {
    this.GetTelefoneClienteById(this.clienteId)
  },

  updated() {},

  data() {
    return {
			numeroTelefone: "",
		}
  },

  methods: {
  },

  computed: {}
})
</script>

<template>
  
  <InputTelefone v-model="numeroTelefone" @invalido="$emit('invalido',$event)" @update:modelValue="$emit('update:modelValue',$event)"/>
</template>

<style scoped></style>
